module.exports = __webpack_public_path__ + "media/images/lisanne-775c10bf57b662173831fe5a333c665d.png";